// extracted by mini-css-extract-plugin
export default {"productCarousel":"w2-z"};